import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'
import { useProductPrice } from '~/scopes/product-core/composables/useProductPrice/useProductPrice'

export function useFetchProductPrice() {
  const { selectedOffer } = useFetchPickers()
  const { data: servicesPickersResponse } = useFetchServicePickers()

  return useProductPrice({
    pickers: servicesPickersResponse,
    selectedOffer,
  })
}
